import {createSlice} from '@reduxjs/toolkit'
import hit from 'src/services/manager'

const initialState={
    list:[]
}

const faqsSlice=createSlice({
    name:"faqs",
    initialState,
    reducers:{
        setFaqList:(state,action)=>{
            state.list=action.payload
        }
    }
})

export const {setFaqList}=faqsSlice.actions

export const getFAQListThunk=()=>{
    return async(dispatch)=>{
        try{
            let res=await hit("/faqs","get")
            if(!res.err){
                dispatch(setFaqList(res?.data))
            }
        }catch(err){

        }finally{

        }
    }
}

export default faqsSlice.reducer